var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"position-absolute fixed-bottom text-center bg-dark p-3"},[_c('span',[_vm._v("Copyright © "+_vm._s(new Date().getFullYear())+" The Mad Monkeys")])])}
var staticRenderFns = []

export { render, staticRenderFns }